'use strict'

module.exports = html

var u = require('unist-builder')

/* Return either a `raw` node, in dangerous mode, or
 * nothing. */
function html(h, node) {
  return h.dangerous ? h.augment(node, u('raw', node.value)) : null
}



//////////////////
// WEBPACK FOOTER
// ./~/remark-react/~/mdast-util-to-hast/lib/handlers/html.js
// module id = 893
// module chunks = 95715928098905 168707334958949